import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import { gsap } from "gsap";
import {degrees_to_radians} from './Utils.js';


export default class CharacterController{

  constructor(){
    this.keyHash = {};
    this.body = null;
    this.inputVelocity = new THREE.Vector3();
    this.targetRotation = 0;
    this.maxSpeed = 6;//2;
    this.baseSpeed = 2;
    this.prevAnimation = null;
    this.animation = null;
    this.mobileTargetRotation = 0;
    this.rotationSpeedL = 0;
    this.rotationSpeedR = 0;
    this.moveSpeedFactor = 1;
    this.rotationSpeedMax = 100.0;//1.75;
    // in use?
    this.flyLimit = 20;
    this.flyStrength = 25;
    this.flyMax = 30;
    this.powerUpAnimation = [];
    this.angleBase = degrees_to_radians(10);

    this.AXIS_Y = new THREE.Vector3( 0, 1, 0 );
    this.moveDir = new THREE.Vector3( 0, 0, 0 );
    this.impulse = new CANNON.Vec3(0,0,0);

  }

  init(mass,shape,position,material){
    // const material = new CANNON.Material({friction:200})

    //const radius = 1; // m
    this.body = new CANNON.Body({
      mass: mass,
      shape: shape,
      linearDamping: .99999999,
      angularDamping: .9999999,
      material: material
    });

    this.body.position.set(position.x,position.y,position.z);

    this.group = new THREE.Group();

    let geo = new THREE.BoxGeometry(.15,.15,.5);
    let mesh = new THREE.Mesh(geo, new THREE.MeshStandardMaterial({color:0xff0000,transparent:true,opacity:.5}));

    this.group.add(mesh);

  }

  doPowerUp(duration=60){
    this.powerUpAnimation = [];
    this.maxSpeed = 3.5;

    let speed = {val:this.maxSpeed};
    let anim = gsap.to(speed,{val:this.baseSpeed,duration:duration,overwrite:true,onUpdate:function(){
      this.maxSpeed = speed.val;
    }.bind(this)});
    this.powerUpAnimation.push(anim);

    this.flyMax = 30;
    let anim2 = gsap.to(this,{flyMax:20,duration:duration,overwrite:true});
    this.powerUpAnimation.push(anim2);
    this.flyLimit = 20;
    let anim3 = gsap.to(this,{flyLimit:5,duration:duration,overwrite:true});
    this.powerUpAnimation.push(anim3);

  }

  endPowerUp(){
    if(this.powerUpAnimation){
      this.powerUpAnimation.forEach((item, i) => {
        item.kill();
      });
    }

    this.maxSpeed = this.baseSpeed;
  }

  setKeyHash(key){
    this.keyHash[key] = true;
  }

  cancelIdle(){
    clearTimeout(this.idelTM);
    this.idelTM = null;
    this.animation = null;
  }

  update(dt, camera){


    let force = 0;
    let inputForce = 40;
    this.inputVelocity.set(0, 0, 0);
    this.AXIS_Y.set( 0, 1, 0 );
    this.moveDir.set( 0, 0, 0 );
    this.moveDir.subVectors( this.body.position, camera.position ).y = 0;

    // if(this.doRec)
    //   this.moveDir.copy(this.body.position).y = 0;
    //

    let animation = null;

    if( this.keyHash.ArrowUp || this.keyHash['w'] || this.keyHash['W']){ force = inputForce*dt; animation = "walk"; }
    else if( this.keyHash.ArrowDown || this.keyHash['s'] || this.keyHash['S']){ force = -inputForce*dt; animation = "walk";}

    if( this.keyHash.ArrowLeft || this.keyHash['a'] || this.keyHash['A']){
      let angleChange = this.angleBase*this.rotationSpeedL;
      this.moveDir.applyAxisAngle( this.AXIS_Y, angleChange ); animation = "walk"; }
    else if( this.keyHash.ArrowRight || this.keyHash['d'] || this.keyHash['D']){
      let angleChange = this.angleBase*this.rotationSpeedR;
      this.moveDir.applyAxisAngle( this.AXIS_Y, -angleChange ); animation = "walk"; }

    let rotationMultiplier = 1.25;//1.1

    if(this.keyHash.ArrowLeft || this.keyHash['a'] || this.keyHash['A']){
      this.rotationSpeedL += dt*1.1;
      this.rotationSpeedL = Math.min(this.rotationSpeedL,this.rotationSpeedMax*dt);
    }else{
      this.rotationSpeedL = 0;
    }

    if(this.keyHash.ArrowRight || this.keyHash['d'] || this.keyHash['D']){
      this.rotationSpeedR += dt*rotationMultiplier;
      this.rotationSpeedR = Math.min(this.rotationSpeedR,this.rotationSpeedMax*dt);
    }else{
      this.rotationSpeedR = 0;
    }

    if(this.keyHash.ArrowUp || this.keyHash.ArrowDown  || this.keyHash['w'] || this.keyHash['s'] || this.keyHash['W'] || this.keyHash['S']){
      this.moveSpeedFactor += .01;
      this.moveSpeedFactor = Math.min(this.moveSpeedFactor,1.5);
      this.moveSpeedFactor = Math.max(this.moveSpeedFactor,1);
    }else{
      this.moveSpeedFactor = 1;
      // this.body.velocity.set(0,0,0);
    }


    this.moveDir.normalize();

    this.inputVelocity.x = this.moveDir.x * force;
    this.inputVelocity.z = this.moveDir.z * force;
    this.inputVelocity.setLength(this.maxSpeed * 10 * dt * this.moveSpeedFactor); // clamps walking speed

    if( this.keyHash[' ']){
      this.inputVelocity.y = this.flyStrength * dt;//.35;
      animation = "jump";
    }

    //const impulse = new CANNON.Vec3(this.inputVelocity.x, this.inputVelocity.y, this.inputVelocity.z);
    this.impulse.set(this.inputVelocity.x, this.inputVelocity.y, this.inputVelocity.z);
    this.targetRotation = Math.atan2( this.moveDir.x, this.moveDir.z );

    this.body.applyImpulse(this.impulse);

    if( (animation != "jump" && this.animation != "idle") && this.body.velocity.length() < .01 ){
      animation = null;
    }else if(animation == null && this.animation == "idle" ){
      animation = "idle";
    }else if(this.body.position.y > .4 && animation != "walk"){
      animation = "jump";
    }

    if(animation == null && !this.idelTM){

      this.idelTM = setTimeout(function(){
        this.animation = "idle";
        clearTimeout(this.idelTM);
        this.idelTM = null;
      }.bind(this), 5000);
    }

    if(this.animation == "dance" && animation != "walk"){
      animation = "dance";
      if(this.prevAnimation != "dance"){
        clearTimeout(this.idelTM);
        this.idelTM = setTimeout(function(){
          this.animation = "idle";
          this.idelTM = null;
        }.bind(this), 5000);
      }
    }

    this.prevAnimation = this.animation;
    this.animation = animation;
    this.group.position.copy(this.body.position);
    // console.log(this.body.velocity);
    //this.group.quaternion.copy(this.body.quaternion);
  }

};
